import { useFormField, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { SwitchInput } from '@calendly/ui/components/switch-input'
import { TextInput } from '@calendly/ui/components/text-input'
import { LabelText } from '@calendly/ui/components/typography'
import classNames from 'classnames'
import { useCallback } from 'react'

import { LIMIT_TYPES, MAX_EVENT_LIMIT } from 'components/event_type_edit/event_limits/constants'

import {
  limitsRowCss,
  limitsRowDisabledCss,
  limitsRowEnabledCss,
  limitsRowNumberInputCss,
  limitsRowStatusCss,
  limitsRowSwitchGroupCss,
  limitsRowSwitchInputWrapCss,
  limitsRowSwitchLabelCss,
  limitsRowValueCss,
} from './styles'

const LIMIT_LABELS = {
  dailyLimit: () => I18n.t('publisher.event_type_editor_crud.scheduling_limits.per_day'),
  weeklyLimit: () => I18n.t('publisher.event_type_editor_crud.scheduling_limits.per_week'),
  monthlyLimit: () => I18n.t('publisher.event_type_editor_crud.scheduling_limits.per_month'),
}

const LimitRowNumberInput = ({
  ariaLabel,
  name,
}) => {
  const [fieldProps, meta] = useFormField({ name })

  return (
    <TextInput
      {...fieldProps}
      aria-invalid={meta.touched && Boolean(meta.error)}
      aria-label={ariaLabel}
      centered
      className={limitsRowNumberInputCss}
      inputMode="numeric"
      max={MAX_EVENT_LIMIT}
      min={0}
      size="small"
      spacingBottom={0}
      spacingTop={0}
      type="text"
    />
  )
}

export const EventTypeLimitRow = ({
  limitType,
  isLocked = false,
}) => {
  const { values, setFieldValue } = useFormContext()
  const limitValue = values[limitType]
  const isEnabled = limitValue !== undefined && limitValue !== null
  const limitLabel = LIMIT_LABELS[limitType]()
  const switchId = `event-type-limit-switch-${limitType}`

  const handleToggle = useCallback(() => {
    setFieldValue(limitType, isEnabled ? undefined : 0)
  }, [isEnabled, limitType, setFieldValue])

  const showLimitInput = isEnabled && !isLocked

  return (
    <div
      className={classNames(
        limitsRowCss,
        showLimitInput ? limitsRowEnabledCss : limitsRowDisabledCss,
      )}
      data-testid={`event-type-limit-row-${limitType}`}
    >
      <label className={limitsRowSwitchGroupCss} htmlFor={switchId}>
        <span className={limitsRowSwitchInputWrapCss}>
          <SwitchInput
            id={switchId}
            checked={isEnabled}
            disabled={isLocked}
            aria-label={limitLabel}
            onChange={handleToggle}
            spacingBottom={0}
            spacingTop={0}
          />
        </span>
        <LabelText className={limitsRowSwitchLabelCss} size="large">
          {limitLabel}
        </LabelText>
      </label>
      <div className={limitsRowValueCss}>
        {showLimitInput ? (
          <>
            <LimitRowNumberInput
              ariaLabel={limitLabel}
              name={limitType}
            />
            <LabelText color="muted" size="large">
              {I18n.t('publisher.event_type_editor_crud.scheduling_limits.meetings')}
            </LabelText>
          </>
        ) : (
          <LabelText className={limitsRowStatusCss} color="muted" size="large">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.no_limit')}
          </LabelText>
        )}
      </div>
    </div>
  )
}

export const EVENT_TYPE_LIMIT_TYPES = LIMIT_TYPES
